import {
  Typography as Text,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

import { DateUtils } from '@spotify/confidence-core-react';
import { IdentityRefFragment } from '@spotify/confidence-graphql';
import { IdentityAvatar } from '@spotify/plugin-confidence-iam-react';

const styles = () =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      padding:
        'var(--encore-spacing-tighter-2) var(--encore-spacing-tighter-2)',
      paddingLeft: 0,
    },
    avatar: {
      width: '18px',
      height: '18px',
      marginRight: 'var(--encore-spacing-tighter-2)',
      flexShrink: 0,
    },
    content: {
      flex: 1,
      minWidth: 0,
    },
  });

export interface HeaderProps extends WithStyles<typeof styles> {
  className?: string;
  actor?: IdentityRefFragment | null;
  timestamp: string;
}

const Header = ({ actor, timestamp, classes, className }: HeaderProps) => (
  <div className={classNames(classes.root, className)}>
    {actor && <IdentityAvatar className={classes.avatar} identityRef={actor} />}
    <div className={classes.content}>
      <Text component="div" variant="body2" color="textSecondary" noWrap>
        {DateUtils.xAgo(new Date(timestamp))}
        {actor?.displayName && <> &bull; {actor.displayName}</>}
      </Text>
    </div>
  </div>
);

export default withStyles(styles)(Header);
